export class Machine {
  id?:number;
  serial_number:string = "";
  model:string = "";
  machine_number:string = "";
  client_name:string = "";

  constructor(raw?:{[id:string]:any}) {
    this.id = raw && raw.id || 0
    this.serial_number = raw && raw.serial_number || "";
    this.model = raw && raw.model || "";
    this.machine_number = raw && raw.machine_number || "";
    this.client_name = raw && raw.client_name || "";
  }

  static clone(from:Machine): Machine {
    return new Machine(from)
  }
}